import React from 'react'
import { Helmet } from "react-helmet";
import "../../styles/SearchMap.css";
import kleenhub_logo from "../../Images/plain_logo.png";
import kleenhub_card from "../../Images/card.png";
import { Box, Button, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Modal } from '@mui/material';
import { LoadingComponent } from '../../components/LoadingComponent';
import swal from 'sweetalert';
import { getCardData, removeCardData } from '../../Services/Events.services';
import AddPayment from './AddPayment';
import { useNavigate } from "react-router-dom";
import { ArrowBack, DeleteOutline } from '@mui/icons-material';
const webSiteUrl = 'https://kleenhub.com';

export const PaymentMethods = () => {
    const history = useNavigate();
    const [spinnerList, setSpinnerList] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [cardData, setCardData] = React.useState([]);
    const [dataFetched, setDataFetched] = React.useState(null);

    React.useEffect(() => {
        getConsumerCards();
    }, []);

    const getConsumerCards = async () => {
        try {
            setSpinnerList(true);
            const response = await getCardData();
            if (response.status === 200) {
                const data = await response?.data;
                if (data) {
                    setCardData(data.cardAllData);
                    setDataFetched(true)
                }
            }
            setSpinnerList(false);
        } catch (err) {
            setSpinnerList(false)
            swal('Error', err.response.data.message, 'error');
        }
    };


    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        document.title = 'kleen hub - Payment Methods';  
    }, []);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const goBackHome = () => {
        history("/home");
    }

    const handleDeleteItem = (event) => {
        const buttonId = event.currentTarget.id;
        swal({
            title: "Are you sure?",
            text: "By clicking ok you're confirming to delete the card from kleenhub system.",
            icon: "warning",
            buttons: [
                'No, cancel it!',
                'Yes, I am sure!'
            ],
            dangerMode: true,
        }).then(async (isConfirm) => {
            if (isConfirm){
                try {
                    setSpinnerList(true);
                    const response = await removeCardData(buttonId);
                    if (response.status === 200) {
                        const response = await getCardData();
                        if (response.status === 200) {
                            const data = await response?.data;
                            if (data) {
                                setCardData(data.cardAllData);
                                setDataFetched(true)
                            }
                        }
                    }
                    setSpinnerList(false);
                } catch (err) {
                    setSpinnerList(false)
                    swal('Error', err, 'error');
                }
            }
        });
    }
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        borderRadius: '10px',
        boxShadow: 24,
        p: 4,
    };

    const cardList = () => {
        if (cardData.length > 0)
            return (
            <List style={{ marginTop: '50px' }}>
                {(dataFetched && cardData && cardData?.length > 0) && 
                    cardData?.map((card) => {
                        return(
                            <ListItem> 
                            <ListItemButton> 
                                <ListItemText>
                                    <p className='card-text-content' >
                                        ({card.brand})  xxxx-xxxx-xxxx-{card.last4}
                                        <br/>
                                        {card.expMonth} / {card.expYear}
                                    </p>
                                </ListItemText>
                                <ListItemIcon> 
                                    <IconButton id={card.id} aria-label="back" variant="outlined" color="error" onClick={handleDeleteItem}>
                                        <DeleteOutline fontSize='medium'/>
                                    </IconButton> 
                                </ListItemIcon>
                            </ListItemButton> 
                        </ListItem> 
                        )
                    })
                }
            </List> 
            )
        else
            return (
                <div style={{ display: 'block', position: 'absolute', left: '25%', marginTop: '80%' }}>
                    <p className='text-content-left' style={{ fontSize: '25px', position: 'relative', marginTop: '-190px', textAlign: 'center', padding: '0px' }}>
                        No saved cards
                    </p>
                </div>
            );
    }

    const RegistrationSuccess = () => {
        return (dataFetched && (
            <LoadingComponent loader={spinnerList}>
                <div style={{ maxWidth: '420px', position: 'absolute', maxHeight: '450px', 
                top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                    <a className='title' style={{ maxWidth: '420px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                        <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                    </a>
                    <div className="img-payment" id="first-page">
                        <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={kleenhub_card}/>
                        <div className='div-text'>
                            <div id="oval_parent" className="multi-ellipse" style={{ top: '-160px', display: 'block' }}>
                                <div id="oval"></div>
                            </div>
                            <div className="vertical-left" style={{ transform: 'translateY(-720%)', display: 'block' }} >
                                <IconButton aria-label="back" variant="outlined" color="success" onClick={goBackHome}>
                                    <ArrowBack fontSize='large'/>
                                </IconButton>
                            </div>
                            <div style={{ display: 'block', position: 'relative', marginTop: '-70%' }}>
                                <Button variant="outlined"
                                    style={{ backgroundColor: 'transparent', borderRadius: "50%", left: '33%', lineHeight: '1', width: "160px", height: "68px",
                                    fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                    textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                    disableRipple={true}
                                    onClick={handleOpen}
                                    >
                                        Add New Card
                                </Button>
                            </div>
                            {cardList()}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                >
                                <Box sx={style}>
                                    <AddPayment/>
                                </Box>
                            </Modal>
                        </div>
                    </div>
                </div>
            </LoadingComponent>
        ))
    }

    return (
        <div>
            <Helmet>
                <title>kleenhub</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {
                RegistrationSuccess()
            }
        </div>
    )
}
